<span *ngFor="let option of dataArray" [ngClass]="option.class" [hidden]="!option.text">
    {{option.text}}
    <i style="padding-left: 5px" [hidden]="!option.ngbPopover" [ngClass]="option.ngbPopoverClass"
        class="fas fa-info-circle" [ngbPopover]="popContent" container="body" triggers="mouseenter:mouseleave"></i>
    <ng-template #popContent>
        <div [innerHTML]="sanitizerHtml(option.ngbPopover)"></div>
    </ng-template>
</span>